export default __webpack_public_path__ + "static/media/k2_srna-min.d4bf476d.jpg";